import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["yearSelect","effectiveDateSelect", "noEnrollmentsMsg", "confirmChangesModal", "summaryContent", "summaryYear", "summaryEffectiveDate", "summaryContributions", "loadingOverlay"]

  generateEffectiveDates(e) {
    const target = e.target;
    if (!target || target.id !== "eligibility_year") return;

    const selectedYear = target.value;
    const url = target.dataset.url;
    const effectiveSelect = this.effectiveDateSelectTarget;
    const noMsg = this.noEnrollmentsMsgTarget;
    const selectEnrollmentEffectiveDateLabel = this.element.dataset.selectEnrollmentLabelValue;

    if (!effectiveSelect) return;

    effectiveSelect.innerHTML = "";
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = selectEnrollmentEffectiveDateLabel;
    effectiveSelect.appendChild(defaultOption);
    effectiveSelect.disabled = true;
    effectiveSelect.required = false;

    if (noMsg) noMsg.style.display = "none";
    if (!selectedYear || !/^\d{4}$/.test(selectedYear)) return;
    if (!url) return;

    let requestUrl;
    try {
      requestUrl = new URL(url, window.location.origin);
      if (requestUrl.origin !== window.location.origin) {
        return;
      }
    } catch (err) {
      return;
    }

    requestUrl.searchParams.set("year", selectedYear);
    fetch(requestUrl.toString(), {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        credentials: "same-origin"
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Invalid content type");
        }
        return response.json();
      })
      .then((data) => {
        if (typeof data !== "object" || data === null) {
          throw new Error("Invalid response format");
        }

        const items = Array.isArray(data) ?
          data :
          (Array.isArray(data.effective_dates) ? data.effective_dates : []);

        if (items.length === 0) {
          effectiveSelect.disabled = true;
          effectiveSelect.required = false;
          if (noMsg) noMsg.style.display = "";
          return;
        }

        items.forEach((d) => {
          if (typeof d !== "string" || !/^[\d\-\/]+$/.test(d)) return;

          const opt = document.createElement("option");
          opt.value = d;
          opt.textContent = d;
          effectiveSelect.appendChild(opt);
        });

        effectiveSelect.disabled = false;
        effectiveSelect.required = true;
        if (noMsg) noMsg.style.display = "none";
      })
      .catch((err) => {
        effectiveSelect.disabled = true;
        if (noMsg) noMsg.style.display = "";
      });
  }

  showModal(e) {
    e.preventDefault()

    const form = this.element.querySelector('form')
    if (form && !form.checkValidity()) {
      form.reportValidity()
      return
    }

    this.populateSummary()
    if (this.hasConfirmChangesModalTarget) {
      $(this.confirmChangesModalTarget).modal('show')
    }
  }

  populateSummary() {
    const yearSelect = this.yearSelectTarget;
    const selectedYear = yearSelect.options[yearSelect.selectedIndex]?.text
    const noActiveEnrollmentMessage = this.element.dataset.noActiveEnrollmentFoundForYearMessageValue;
    const selectEnrollmentEffectiveDateLabel = this.element.dataset.selectEnrollmentLabelValue;

    this.summaryYearTarget.textContent = selectedYear;

    const effectiveDateSelect = this.effectiveDateSelectTarget;
    const selectedEffectiveDate = effectiveDateSelect ? effectiveDateSelect.options[effectiveDateSelect.selectedIndex]?.text : ''
    const effectiveDateValue = (selectedEffectiveDate == selectEnrollmentEffectiveDateLabel) ? noActiveEnrollmentMessage : selectedEffectiveDate

    this.summaryEffectiveDateTarget.textContent = effectiveDateValue;

    const contributionInputs = this.element.querySelectorAll('input[name*="monthly_expected_contribution"]')
    this.summaryContributionsTarget.innerHTML = ''

    const headerSpan = document.createElement('span')
    headerSpan.textContent = 'Group contribution amount:'
    this.summaryContributionsTarget.appendChild(headerSpan)

    contributionInputs.forEach((input, index) => {
      const value = input.value || '0'

      const p = document.createElement('p')
      p.className = 'ml-3'

      const labelText = document.createTextNode(`Group ${index + 1}: `)
      p.appendChild(labelText)

      const strong = document.createElement('strong')
      strong.textContent = `$${value}`
      p.appendChild(strong)

      this.summaryContributionsTarget.appendChild(p)
    })
  }

  confirm(e) {
    e.preventDefault()
    this.showLoading()

    // Safety timeout - hide loading after 10 seconds
    this.loadingTimeout = setTimeout(() => {
      this.hideLoading()
    }, 10000)

    if (this.hasConfirmChangesModalTarget) {
      $(this.confirmChangesModalTarget).modal('hide')
    }

    const form = this.element.querySelector('form')
    if (form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit()
      } else if (window.Rails && typeof Rails.fire === 'function') {
        Rails.fire(form, 'submit')
      } else {
        const event = new Event('submit', { bubbles: true, cancelable: true })
        form.dispatchEvent(event)
      }
    }
  }

  showLoading() {
    if (this.hasLoadingOverlayTarget) {
      this.loadingOverlayTarget.classList.remove('d-none')
      this.loadingOverlayTarget.style.display = 'block'
    }
  }

  hideLoading() {
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = null
    }

    if (this.hasLoadingOverlayTarget) {
      this.loadingOverlayTarget.classList.add('d-none')
      this.loadingOverlayTarget.style.display = 'none'
    }
  }

  close() {
    if (this.hasConfirmChangesModalTarget) {
      $(this.confirmChangesModalTarget).modal('hide')
    }
  }
}
